import type { BrandingJson } from "./types";

export function applyBranding(branding: BrandingJson | undefined | null): void {
  if (!branding) return;
  const root = document.documentElement;
  if (branding.colors?.primary) {
    root.style.setProperty("--brand-primary", branding.colors.primary);
    // Dieselbe Farbe als drei Zahlen – dafür gibt es Deckkraft-Stufen
    // wie bg-brand-primary/10 (siehe tailwind.config.js).
    const rgb = hexZuRgb(branding.colors.primary);
    if (rgb) root.style.setProperty("--brand-primary-rgb", rgb);
  }
  if (branding.colors?.secondary) root.style.setProperty("--brand-secondary", branding.colors.secondary);
  if (branding.colors?.accent) root.style.setProperty("--brand-accent", branding.colors.accent);
  if (branding.colors?.background) root.style.setProperty("--brand-bg", branding.colors.background);
  if (branding.colors?.text) root.style.setProperty("--brand-text", branding.colors.text);
  if (branding.name) document.title = `${branding.name} – webradiosuite`;
}

/** "#ff5500" oder "#f50" → "255 85 0"; alles andere → null. */
export function hexZuRgb(hex: string): string | null {
  const m = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(hex.trim());
  if (!m) return null;
  const h = m[1].length === 3 ? m[1].split("").map((c) => c + c).join("") : m[1];
  const n = parseInt(h, 16);
  return `${(n >> 16) & 255} ${(n >> 8) & 255} ${n & 255}`;
}
